module.exports = __webpack_public_path__ + "img/junting_chen.785a7cf6.jpg";